/* EV V4 — toetsenbordtoegang voor de maatswatches.

   Swatch King rendert zijn maatknoppen als <div class="swatch-button"> zonder
   role, zonder tabindex en zonder toegankelijke naam. Daardoor kan iemand die
   geen muis gebruikt geen maat kiezen, en dus niets kopen. Dat is een
   WCAG 2.1 AA-fout (2.1.1 Toetsenbord) midden op de koopweg.

   De kleuroptie heeft dit probleem niet: die rendert de app als echte links
   naar de losse kleurproducten, en die zijn al bereikbaar.

   Deze laag raakt de app niet aan en verandert niets aan het klikgedrag. Hij
   voegt alleen de ontbrekende semantiek toe: een radiogroep met radio's, een
   naam per knop, en de pijltjes- plus Enter/spatie-bediening die daarbij hoort.
   Omdat de app zijn knoppen asynchroon en na elke variantwissel opnieuw
   neerzet, blijft een MutationObserver kijken in plaats van eenmalig te draaien.
*/
(function () {
  var GROUP = '[option-target]';
  var BTN = '.swatch-button';

  function label(btn) {
    return (btn.getAttribute('data-value') || btn.textContent || '').trim();
  }

  function enhance(group) {
    var buttons = [].slice.call(group.querySelectorAll(BTN));
    if (!buttons.length) return;

    var name = group.getAttribute('option-name') || 'Option';
    if (group.getAttribute('role') !== 'radiogroup') {
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', name);
    }

    buttons.forEach(function (btn) {
      var selected = btn.classList.contains('swatch-selected');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      // Alleen de gekozen knop zit in de tabvolgorde; binnen de groep loop je
      // met de pijltjes. Dat is het standaardpatroon voor een radiogroep.
      btn.setAttribute('tabindex', selected ? '0' : '-1');
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', name + ' ' + label(btn));
      if (btn.classList.contains('swatch-unavailable') || btn.classList.contains('swatch-sold-out')) {
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function move(group, from, step) {
    var buttons = [].slice.call(group.querySelectorAll(BTN));
    var i = buttons.indexOf(from);
    if (i === -1) return;
    var next = buttons[(i + step + buttons.length) % buttons.length];
    next.setAttribute('tabindex', '0');
    from.setAttribute('tabindex', '-1');
    next.focus();
    next.click();
  }

  document.addEventListener('keydown', function (event) {
    var btn = event.target.closest ? event.target.closest(BTN) : null;
    if (!btn) return;
    var group = btn.closest(GROUP);
    if (!group) return;

    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      btn.click();
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      move(group, btn, 1);
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      move(group, btn, -1);
    }
  });

  function run() {
    [].slice.call(document.querySelectorAll(GROUP)).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // De app zet zijn knoppen asynchroon neer en opnieuw na elke variantwissel, dus
  // er moet iets blijven kijken. Zonder rem kost dat te veel: een observer die bij
  // elke DOM-wijziging over de hele pagina loopt tilde de total blocking time op
  // deze winkel van ~300 ms naar ~1000 ms, omdat de apps voortdurend muteren.
  // Daarom twee remmen: alleen reageren op mutaties die daadwerkelijk een swatch
  // raken, en het werk samenvoegen tot één keer per frame.
  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  function touchesSwatch(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && (node.matches(BTN) || node.matches(GROUP))) return true;
    return !!(node.querySelector && node.querySelector(BTN));
  }

  // Een variantwissel verandert alleen de classes op bestaande knoppen, niet de
  // DOM-structuur, dus de observer hierboven ziet dat niet. Na een klik wordt de
  // groep daarom opnieuw nagelopen, zodat aria-checked en de tabvolgorde kloppen.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest(BTN) : null;
    if (!btn) return;
    var group = btn.closest(GROUP);
    if (group) requestAnimationFrame(function () { enhance(group); });
  });

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (touchesSwatch(added[j])) { schedule(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* --------------------------------------------------------------------------
   20 aug: focus in het zoekveld zodra de zoekpopup opengaat.
   Keira meldde dat zoeken niet werkte. De hoofdoorzaak was de plaatsing van de
   popup (zie theme.css, blok "EV V4 - search"), maar ook daarna moest je na het
   klikken op het vergrootglas eerst nog in het veld klikken voordat je kon
   typen. Het thema doet dat zelf niet. Toetsenbordgebruikers zaten met dezelfde
   omweg: de popup opende zonder dat de focus meeging.
   -------------------------------------------------------------------------- */
(function () {
  var modal = document.getElementById('header-search-mobile-modal');
  if (!modal) return;
  modal.addEventListener('dialog:after-show', function () {
    var input = modal.querySelector('input[type="search"]');
    if (input) requestAnimationFrame(function () { input.focus(); });
  });
})();

/* --------------------------------------------------------------------------
   20 aug: maatfilter met samengevoegde waarden.
   Een zichtbaar vinkje in het maatfilter kan meer dan één ruwe optiewaarde
   dekken (XL staat ook voor "XL/2XL" en voor "XL - 38DDD 38G 40DD 40DDD").
   De extra waarden staan als verborgen velden naast het vinkje en zijn
   uitgeschakeld, zodat ze niet meesturen als de maat niet gekozen is. Hier
   volgen ze het vinkje. Zie de toelichting in snippets/facets.liquid.
   -------------------------------------------------------------------------- */
(function () {
  function sync(group) {
    var box = group.querySelector('input[type="checkbox"]');
    if (!box) return;
    var extras = group.querySelectorAll('[data-ev-size-extra]');
    for (var i = 0; i < extras.length; i++) extras[i].disabled = !box.checked;
  }

  document.addEventListener('change', function (event) {
    var group = event.target.closest ? event.target.closest('[data-ev-size-group]') : null;
    if (group) sync(group);
  });

  function syncAll(root) {
    var groups = (root || document).querySelectorAll('[data-ev-size-group]');
    for (var i = 0; i < groups.length; i++) sync(groups[i]);
  }

  syncAll();
  /* De filterkolom wordt na elke keuze opnieuw opgebouwd, dus na een vervanging
     opnieuw synchroniseren. */
  new MutationObserver(function () { syncAll(); })
    .observe(document.body, { childList: true, subtree: true });
})();

/* --------------------------------------------------------------------------
   20 aug: breedte van de vrije-verzendbalk bijwerken.
   Het thema-element <free-shipping-bar> vult alleen de tekst, maar houdt het
   attribuut total-price wel bij zodra de winkelwagen verandert. Hier wordt die
   waarde tegen de drempel afgezet en op de balk gezet. Zie de toelichting in
   snippets/free-shipping-bar.liquid.
   -------------------------------------------------------------------------- */
(function () {
  function update(bar) {
    var fill = bar.querySelector('.free-shipping-bar__fill');
    if (!fill) return;
    /* Het element rekent de drempel bij het aanmaken om naar centen en schrijft
       die terug in hetzelfde attribuut, dus hier is geen tweede omrekening nodig. */
    var threshold = parseFloat(bar.getAttribute('threshold'));
    var total = parseFloat(bar.getAttribute('total-price'));
    if (!threshold || isNaN(total)) return;
    fill.style.inlineSize = Math.max(0, Math.min(100, (total / threshold) * 100)) + '%';
  }

  function watch(bar) {
    if (bar.__evFsWatched) return;
    bar.__evFsWatched = true;
    update(bar);
    new MutationObserver(function () { update(bar); })
      .observe(bar, { attributes: true, attributeFilter: ['total-price', 'threshold'] });
  }

  function scan() {
    var bars = document.querySelectorAll('free-shipping-bar');
    for (var i = 0; i < bars.length; i++) watch(bars[i]);
  }

  scan();
  /* De lade wordt na elke wijziging opnieuw opgebouwd, dus nieuwe balken oppikken. */
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();

/* --------------------------------------------------------------------------
   20 aug: de persstrook moet op desktop in het eerste beeld staan.
   De hero rekent zijn hoogte uit tegen de viewport, dus de strook eronder valt
   er per definitie buiten. In theme.css wordt de hoogte van de strook van de
   hero afgetrokken; hier wordt die hoogte gemeten en doorgegeven. Meten in
   plaats van vastzetten, omdat de hoogte meebeweegt met de logobreedte en de
   ruimte die in de sectie-instellingen staat.
   -------------------------------------------------------------------------- */
(function () {
  var MIN_DESKTOP = 1000;

  function measure() {
    var hero = document.querySelector('.shopify-section:first-of-type .content-over-media--fill');
    if (!hero) return;
    var strip = document.querySelector('.scrolling-content-main');
    if (!strip) return;
    var section = strip.closest('[id^="shopify-section"]') || strip;
    var h = Math.round(section.getBoundingClientRect().height);
    if (!h || window.innerWidth < MIN_DESKTOP) {
      document.documentElement.style.removeProperty('--ev-press-strip-height');
      return;
    }
    document.documentElement.style.setProperty('--ev-press-strip-height', h + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);
})();
